import { DuviNicheSiteButton } from "@/components/duvi-niche-site-button";

export interface DuviNicheSiteCtaBandProps {
  heading: string;
  subheading?: string;
  ctaLabel: string;
  /** Registration hand-off on `app.<niche-domain>`. */
  ctaHref: string;
  /** `soft` sits on paper, `tint` on the periwinkle callout. */
  tone?: "soft" | "tint";
}

/**
 * DuviNicheSiteCtaBand — ported from the bespoke Fishwalkers design system's
 * `components/marketing/CtaBand.jsx`
 * (duvi-design/exports/niches/fishwalkers/system.zip): the closing band, one
 * per page, centred on a 760px measure over a banded background.
 */
export function DuviNicheSiteCtaBand({
  heading,
  subheading,
  ctaLabel,
  ctaHref,
  tone = "soft",
}: DuviNicheSiteCtaBandProps) {
  return (
    <section
      className={[
        "w-full py-[var(--section-y)] lg:py-[var(--section-y-lg)]",
        tone === "tint" ? "bg-[var(--tint)]" : "bg-[var(--surface-soft)]",
      ].join(" ")}
    >
      <div className="mx-auto flex w-full max-w-[760px] flex-col items-center gap-[var(--space-5)] px-[var(--container-pad)] text-center">
        <h2 className="font-[family-name:var(--font-display)] text-[length:var(--text-h2-sm)] font-extrabold leading-[var(--leading-heading)] tracking-[var(--tracking-heading)] text-[color:var(--heading)] text-pretty lg:text-[length:var(--text-h2)]">
          {heading}
        </h2>
        {subheading && (
          <p className="m-0 max-w-[var(--measure-lead)] font-[family-name:var(--font-body)] text-[length:var(--text-lead-sm)] leading-[var(--leading-lead)] text-[color:var(--body)] lg:text-[length:var(--text-lead)]">
            {subheading}
          </p>
        )}
        <DuviNicheSiteButton
          href={ctaHref}
          size="lg"
          className="mt-[var(--space-2)]"
        >
          {ctaLabel}
        </DuviNicheSiteButton>
      </div>
    </section>
  );
}
